import React from 'react';
import COLORS from 'constants/colors';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Row, Col, Text, Separator } from '@cuemath/comps';
import { ChalkboardTeacher } from 'styled-icons/fa-solid/ChalkboardTeacher';

import Options from './options';

const NOTIFY_OPTIONS = {
  LANGUAGE: 'LANGUAGE',
};

const StyledCard = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 8px 12px;
`;

const SubHeader = styled(Text)`
  font-weight: 600;
`;

const StyledIcon = styled(ChalkboardTeacher)`
  color: ${COLORS.COLA};
  margin-right: 12px;
`;

const TeacherFeedback = ({ feedback, config }) => {
  const {
    notify_options: notifyOptions = [],
    suggestions,
    language,
    parent_reaction: parentReaction,
  } = feedback || {};
  const { feedback: configFeedback } = config || {};
  const { form = [] } = configFeedback || {};
  const [feedbackData] =
    form.filter(({ rating_title: title }) => title === parentReaction) || [];
  const { questions = [] } = feedbackData || {};

  return (
    <div>
      <Row alignItems="center" nowrap>
        <StyledIcon size={36} />
        <Text size="larger" color={COLORS.COLA}>
          Teacher Post-demo Feedback
        </Text>
      </Row>
      <Separator height={16} transparent />
      <Row>
        <Col sm={7} xs={12} gutter={0} gap={8}>
          <SubHeader color={COLORS.COLA}>Some information about the demo:</SubHeader>
          <Separator height={4} transparent />
          {notifyOptions.map(option => {
            const [question] = questions.filter(({ id }) => id === option) || [];
            const { value } = question || {};

            return (
              <Options
                key={value}
                value={
                  value + (option === NOTIFY_OPTIONS.LANGUAGE ? ` (${language})` : '')
                }
              />
            );
          })}
        </Col>
        <Col sm={5} xs={12} gutter={0} gap={8}>
          <SubHeader color={COLORS.COLA}>Suggestions</SubHeader>
          <Separator height={4} transparent />
          <StyledCard>
            <Text color={COLORS.COLA}>{suggestions}</Text>
          </StyledCard>
        </Col>
      </Row>
    </div>
  );
};

TeacherFeedback.propTypes = {
  config: PropTypes.shape({}),
  feedback: PropTypes.shape({}),
};

TeacherFeedback.defaultProps = {
  config: null,
  feedback: null,
};

export default TeacherFeedback;
